import React from 'react';

import { constants, locale } from '@trqk/utils';

const { MAX_AUDIO_FILE_SIZE_MB } = constants;

export const AudioFileTooLarge = (): JSX.Element => (
    <div style={{ width: 410 }} className="px-2">
        <p className="font-bold text-highlight-orange tracking-wider mb-2">
            {locale.enUS.UPLOAD_AUDIO.TOASTS.AUDIO_FILE_TOO_LARGE.WARNING}
        </p>
        <p className="mb-2">
            {`${locale.enUS.UPLOAD_AUDIO.TOASTS.AUDIO_FILE_TOO_LARGE.BODY.PART_1} ${MAX_AUDIO_FILE_SIZE_MB}${locale.enUS.UPLOAD_AUDIO.TOASTS.AUDIO_FILE_TOO_LARGE.BODY.PART_2}`}
        </p>
        <p className="mb-2">
            {locale.enUS.UPLOAD_AUDIO.TOASTS.AUDIO_FILE_TOO_LARGE.BODY.PART_3}
        </p>
    </div>
);
